module.exports = __webpack_public_path__ + "img/7컷_수정.c5049b90.jpg";